<div class="position-relative vh-100">
  <div class="overflow-x-hidden z-0">
    <router-outlet></router-outlet>
  </div>
  <div class="position-fixed top-with-nav end-0 z-1">
    <app-global-toast aria-live="polite" aria-atomic="true"></app-global-toast>
  </div>
</div>

